var map = {
	"./h5-其他维度.svg": "6c01",
	"./h5-基础能力.svg": "53af",
	"./h5-岗位匹配度.svg": "83f0",
	"./h5-进阶能力.svg": "57a6",
	"./h5-通用素质.svg": "0e59e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "57314";